import React from "react";
import editIcon from "../../../../static/images/edit-icon.png";
import { signedLockedAccess } from "../../../../utils";

export const CharacteristicProgressViewMode = ({ styles, assessmentDetails, assessmentDetailsNew, woundProgressOptions, hideIt, onEdit }) => (
  <>
    {signedLockedAccess(assessmentDetails?.assessmentStage) && hideIt && (
      <div className={`float-sm-right ${styles.tab_edit}`} onClick={onEdit}>
        <img src={editIcon} alt="edit" />
        Edit
      </div>
    )}
    <p>
      <label>Wound Progress:</label>
      <span>
        {assessmentDetailsNew?.woundStage
          ? woundProgressOptions?.find((data) => data.key === assessmentDetailsNew.woundStage.toLowerCase())?.value
          : "-"}
      </span>
    </p>
  </>
);
